(() => {
  const isPP =
    document.body.className.includes('protection-plan-series-sizes') ||
    location.href.includes('view=protection-plan-series-sizes');

  if (!isPP) return;

  const IDS = {
    seriesUl: 'SingleOptionSelector-0-dropdown',
    sizeBtn: 'SingleOptionSelector-1',
    sizeUl: 'SingleOptionSelector-1-dropdown',
  };

  const clean = (s) => (s || '').toString().replace(/\s+/g, ' ').trim();
  const getMaster = () => document.querySelector('select.product-single__variants');

  const parseDim = (label) => {
    const t = clean(label).toLowerCase();
    const isWrap = t.includes('wrap');
    const m = t.match(/(\d+(?:\.\d+)?)\s*["”]?\s*x\s*(\d+(?:\.\d+)?)\s*["”]?/i);
    if (m) return { isWrap, w: Number(m[1]), h: Number(m[2]), ok: true };
    return { isWrap, w: 1e8, h: 1e8, ok: false };
  };

  function sortSizeDropdownList() {
    const ul = document.getElementById(IDS.sizeUl);
    if (!ul) return;

    const items = Array.from(ul.querySelectorAll('li.dropdown-list--item'));
    if (items.length < 2) return;

    items.sort((a, b) => {
      const aDisabled = a.hasAttribute('aria-disabled') || a.classList.contains('disabled');
      const bDisabled = b.hasAttribute('aria-disabled') || b.classList.contains('disabled');
      if (aDisabled !== bDisabled) return aDisabled ? 1 : -1;

      const A = parseDim(a.getAttribute('value') || a.textContent);
      const B = parseDim(b.getAttribute('value') || b.textContent);

      if (A.isWrap !== B.isWrap) return A.isWrap ? 1 : -1;
      if (A.ok !== B.ok) return A.ok ? -1 : 1;
      if (A.w !== B.w) return A.w - B.w;
      return A.h - B.h;
    });

    const frag = document.createDocumentFragment();
    items.forEach((li) => frag.appendChild(li));
    ul.appendChild(frag);
  }

  function getAvailableSizesForSeriesFromMaster(series) {
    const master = getMaster();
    if (!master) return [];

    const seriesPrefix = clean(series) + ' /';
    const sizes = [];

    Array.from(master.options).forEach((o) => {
      if (o.disabled) return;
      const txt = clean(o.textContent);
      if (!txt.startsWith(seriesPrefix)) return;

      const afterSlash = txt.split('/')[1] || '';
      const size = clean((afterSlash.split('-')[0] || '').trim());
      if (size) sizes.push(size);
    });

    return sizes;
  }

  function pickFirstSortedSizeForSeries(series) {
    const sizes = getAvailableSizesForSeriesFromMaster(series);
    if (!sizes.length) return false;

    sizes.sort((a, b) => {
      const A = parseDim(a);
      const B = parseDim(b);
      if (A.isWrap !== B.isWrap) return A.isWrap ? 1 : -1;
      if (A.ok !== B.ok) return A.ok ? -1 : 1;
      if (A.w !== B.w) return A.w - B.w;
      return A.h - B.h;
    });

    const wantSize = sizes[0];

    const tryPick = (tries = 10) => {
      const ul = document.getElementById(IDS.sizeUl);
      if (!ul) {
        if (tries <= 0) return;
        return setTimeout(() => tryPick(tries - 1), 30);
      }

      sortSizeDropdownList();

      const items = Array.from(ul.querySelectorAll('li.dropdown-list--item'));
      const target = items.find(
        (li) => clean(li.getAttribute('value') || li.textContent) === clean(wantSize)
      );

      if (!target) {
        if (tries <= 0) return;
        return setTimeout(() => tryPick(tries - 1), 30);
      }

      const disabled = target.hasAttribute('aria-disabled') || target.classList.contains('disabled');
      if (disabled) return;

      target.dispatchEvent(
        new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window })
      );
    };

    tryPick();
    return true;
  }

  const mo = new MutationObserver(() => {
    setTimeout(sortSizeDropdownList, 0);
  });

  function boot() {
    const ul = document.getElementById(IDS.sizeUl);
    if (ul) mo.observe(ul, { childList: true });

    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest(`#${IDS.sizeBtn}`);
        if (!btn) return;
        setTimeout(sortSizeDropdownList, 0);
      },
      true
    );

    document.addEventListener(
      'mousedown',
      (e) => {
        const li = e.target.closest('li.dropdown-list--item');
        if (!li) return;

        const ul = li.closest('ul.dropdown-list');
        if (!ul || ul.id !== IDS.seriesUl) return;

        const series = clean(li.getAttribute('value') || li.textContent);
        setTimeout(() => pickFirstSortedSizeForSeries(series), 250);
      },
      true
    );

    setTimeout(sortSizeDropdownList, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();